import * as React from "react";

import primaryColour from "../../constants";

function SvgUnrestraineddriving(props: React.SVGProps<SVGSVGElement>) {
  const { fill = primaryColour } = props;
  return (
    <svg width={24} height={25} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.38464 7.71176C4.24501 6.25581 5.46394 5.03688 6.91989 4.17651L8.46499 5.72161L9.05399 5.13161L11.411 7.48836V9.84586L12 10.4351C12.324 10.7589 12.324 11.2896 12 11.6134L10.8215 12.7919C10.4977 13.1159 9.96699 13.1159 9.64324 12.7919L9.05424 12.2029H6.69674L4.33974 9.84586L4.92974 9.25686L3.38464 7.71176ZM9.74424 10.5361H7.38749L6.69724 9.84586L9.05399 7.48836L9.74424 8.17836V10.5361Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0801 21.4072C18.536 20.5469 19.7549 19.328 20.6153 17.872L17.8927 15.1496C18.2165 14.8249 18.2165 14.2951 17.8927 13.9704L15.5357 11.6134C15.212 11.2896 14.6812 11.2896 14.3575 11.6134L10.8215 15.1496C10.4977 15.4734 10.4977 16.0041 10.8215 16.3279L13.1785 18.6849C13.5032 19.0086 14.033 19.0086 14.3577 18.6849L17.0801 21.4072ZM13.7675 16.9171L12.589 15.7386L14.9467 13.3809L16.1252 14.5594L13.7675 16.9171Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgUnrestraineddriving;
